import { Controller } from "@hotwired/stimulus"
import Bridge from "../../src/turbo_native/bridge"

// Sign-out inside the native app is handled by the shell, not by following the
// Devise link — the app has its own session and credential store to clear.
// In a browser this controller does nothing and the link behaves normally.
//
//   li data-controller="turbo-native--sign-out"
//     = link_to t("devise.shared.links.sign_out"), destroy_user_session_path,
//       data: {turbo_method: :delete,
//         action: "turbo-native--sign-out#signOut"}
export default class extends Controller {
  signOut(event) {
    if (!this.isTurboNativeApp) return

    event.preventDefault()
    event.stopImmediatePropagation()
    Bridge.postMessage("signOut")
  }

  get isTurboNativeApp() {
    return navigator.userAgent.includes("Turbo Native")
  }
}
